import { Col, Divider, Row } from 'antd';


const HeureType = ({value}) => {

    
    const valueH =  value.slice(0, 2); 

    return (
        <div style={{width:"100%"}}>

            <Row align="middle" style={{ fontSize: '16px' }}>
                <Col span={4} style={{display:"flex",  }}>
                    <span style={{ fontWeight: 650,  }}>{valueH}  :  </span>
                    <span style={{marginLeft:"5%", marginTop:"11%"}}><Divider style={{ border: '3px solid #43CE0C', width:"3vw", margin:0, padding:0}}  /></span>
                </Col>
                <Col span={1} style={{marginLeft:"-4%"}}>
                     <Divider size='large' type="vertical" style={{ fontSize:"30px", borderLeft: '1.3px solid rgba(0, 0, 0, 0.85)', }}  />
                </Col>
                <Col span={2} style={{ backgroundColor: '#F0EBF8',
                    borderRadius: '2rem', padding:"0.6% 1.4%"}}>
                    <div style={{
                   
                    }}>
                    {value}
                    </div>
                </Col>
            </Row>
            
        </div>
    );
};

export default HeureType;